var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4.84375,
    fill: "#0084B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4167 5.875V9.70833C16.4167 10.2376 16.8457 10.6667 17.375 10.6667H21.2083",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2917 23.125H9.70834C8.64979 23.125 7.79167 22.2669 7.79167 21.2083V7.79167C7.79167 6.73312 8.64979 5.875 9.70834 5.875H16.4167L21.2083 10.6667V21.2083C21.2083 22.2669 20.3502 23.125 19.2917 23.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesDownload);
export default __webpack_public_path__ + "static/media/filesDownload.2ca72eed2ffdf561d3aa98f891524f0a.svg";
export { ForwardRef as ReactComponent };